import { Priority } from '../constants/const';

export type SettingMode = 'file' | 'calculation';

/** 炉数に応じて動的に要素数が変動する配列を表す */
export class FurnacesCountDynamicArray<T> extends Array<T> {}

/** サーバ送信パラメタ */
export class OriginSettingPostAPIParams {
  branchId = 0;
  trashPitCapacity: number[] = new Array(2).fill(0);
  pitLimit = 0;
  pitMax = 0;
  pitMin = 0;
  ashPitCapacity = 0;
  rateCapacity = 0;
  trashDensity = 0;
  ashRate = 0;
  truckMainAshCarryOut = 0;
  flyAshRate = 0;
  burnLoad: FurnacesCountDynamicArray<number>;
  truckFlyAshCarryOut = 0;
  monthlyCarryCalculation: number[] = new Array(12).fill(0);
  weeklyCarryCalculation: number[] = new Array(7).fill(0);
  recycleCostPower: [number, number] = [0, 0];
  otherCostPower: [number, number] = [0, 0];
  settingCsvPath: string = '';

  generatePowers: FurnacesCountDynamicArray<number[]>;
  costPowers: FurnacesCountDynamicArray<number[]>;
  powerSettingCsvRecords: string[][] = [];

  ashPit = 0;
  maxContinuousOperation: [number, number] = [140, 140];
  branchOptional: BranchOptional[] = [];

  constructor(furnacesCount: number) {
    this.burnLoad = new FurnacesCountDynamicArray<number>(furnacesCount).fill(0);
    this.generatePowers = new FurnacesCountDynamicArray(furnacesCount + 1).fill(0).map(() => new Array<number>(12).fill(0)); // 全炉停止を含めた炉数+1で初期化 fillで行うと同じ参照になるのでmapで別オブジェクトにする
    this.costPowers = new FurnacesCountDynamicArray(furnacesCount + 1).fill(0).map(() => new Array<number>(12).fill(0)); // 全炉停止を含めた炉数+1で初期化 fillで行うと同じ参照になるのでmapで別オブジェクトにする
  }
}

export interface BranchOptional {
  optionalId: number;
  optionalShowName: string;
  yearPlanSystemFlag: boolean;
  yearPlanExcelFlag: boolean;
  yearResultSystemFlag: boolean;
  yearResultExcelFlag: boolean;
  monthPlanSystemFlag?: boolean;
  monthPlanExcelFlag?: boolean;
  monthResultSystemFlag?: boolean;
  monthResultExcelFlag?: boolean;
  [key: string]: any;
}

/** 入力フォームオブジェクト */
export class OriginSettingFormValuesObject extends OriginSettingPostAPIParams {
  // 以下、入力/表示はするがサーバ送信しない
  furnacesCount;
  settingMode: SettingMode = 'file';

  public constructor(furnacesCount: number) {
    super(furnacesCount);
    this.furnacesCount = furnacesCount;
    this.settingMode = 'file';
  }

  /** 炉数変更に伴う配列プロパティの初期化 */
  static setFurnacesCount(target: OriginSettingFormValuesObject, newFurnacesCount: number) {
    const furnacesCount = target.burnLoad.length;
    if (furnacesCount === newFurnacesCount) {
      return;
    }

    const newValue = new OriginSettingFormValuesObject(newFurnacesCount);
    // 炉数と配列の要素数が一致しているとは限らないので差分だけを追加・削除
    if (furnacesCount < newFurnacesCount) {
      // 要素追加
      furnacesCountDynamicArrayPropKeys.forEach((key) => {
        (target as any)[key] = (target as any)[key].concat((newValue as any)[key].slice((target as any)[key].length));
      });
    } else if (furnacesCount > newFurnacesCount) {
      // 要素削除
      furnacesCountDynamicArrayPropKeys.forEach((key) => {
        (target as any)[key] = (target as any)[key].slice(0, (newValue as any)[key].length);
      });
    }
  }
}

export const OriginSettingFormIndexMap = Object.keys(new OriginSettingFormValuesObject(1))
  .map((key) => key.replace(/^_/, ''))
  .reduce((map, key, index) => {
    map[key] = index;
    return map;
  }, {} as { [key: string]: number });

const furnacesCountDynamicArrayPropKeys = (() => {
  const obj = new OriginSettingFormValuesObject(1);
  return Object.keys(obj).filter((key) => (obj as any)[key] instanceof FurnacesCountDynamicArray);
})();
